// globalMixin.js
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      // Map state from different modules
      user: state => state.auth.user || null, // Assuming 'auth' is a module and 'user' is a state in that module
      // someOtherState: state => state.someModule.someOtherState // Example for another module
      // Add other states as needed
    })
  }
};
